<template>
    <div class="pay_res">
        <div class="pay_res_a"><img src="../../assets/imgs/pay_suc.png" alt=""></div>
        <div class="pay_res_b">
            <p>Congratulations on your successful payment, the product are: {{ orderInfoData.product_name }}</p>
            <p>Product detail: </p>
            <p class="weight">{{ orderInfoData.shop_content }}</p>
        </div>
        <div class="pay_res_c">
            The goods you purchased have been sent to the in-game mailbox, please log in to the game to check!
        </div>
        <div class="pay_res_d" @click="backIndex">
          <div class="prod_role_btn">Confirm</div> 
        </div>
        <cust></cust>
    </div>
</template>

<script>
import { orderInfo } from '@/api/api';
import { axiosServer } from '@/api/http';
import { Dialog } from 'vant';
import { getSign } from "@/api/utils";
import cust from '../../components/customer.vue'
export default {
  data() {
    return {
      order_id: '',
      orderInfoData: {},
      game_id: '',
      area: '',
      server_id: '',
      role_id: '',
      app_key: '1df869f2e620513484ddbd5521313a60',
    }
  },
  components: {
    cust
  },
  created() {
    this.order_id = this.$route.query.order_id;
    this.game_id = this.$route.query.game_id;
    this.area = this.$route.query.area;
    this.server_id = this.$route.query.server_id;
    this.role_id = this.$route.query.role_id;
    this.getSuccOrderInfo();
  },
  methods: {
    getSuccOrderInfo() {
      axiosServer({
        url: 'orderInfo',
        type: 'post',
        params: {
          order_id: this.order_id,
          sign: getSign(this.app_key, { order_id: this.order_id })
        }
      }).then(resa => {
        let res = resa.data;
        if (res.ret == 0) {
          this.orderInfoData = res.data;
        } else {
          Dialog.alert({ message: res.msg })
        }
      })
      // orderInfo({order_id: this.order_id}).then(res => {
      //   if (res.ret == 0) {
      //     this.orderInfoData = res.data;
      //   } else {
      //     Dialog.alert({ message: res.data.msg })
      //   }
      // })
    },
    backIndex() {
      let game_id = localStorage.getItem('game_id');
      let area = localStorage.getItem('area');
      // this.$router.push({path: '/', query: {game_id: game_id, area: area}});
      if (localStorage.getItem('pc_pay_page')) {
        this.$router.push({path: '/pcpay'});
      } else {
        this.$router.push({path: '/', query: {game_id: this.game_id, area: this.area, server_id: this.server_id, role_id: this.role_id, finish_pay: 1}});
      }
    },
  }
}

</script>

<style lang="scss" scoped>
.pay_res{font-size: 0.28rem;}
.pay_res_a{text-align: center;}
.pay_res_a img{width: 4.6rem;}
.pay_res_d{padding: 0.2rem;}
.pay_res_b{text-align: center;padding: 0.2rem;}
.pay_res_b .weight{font-weight: bold;}
.pay_res_c{margin-top: 1rem;padding: 0 0.3rem;font-size: .28rem;color: #8b8b8b;}
.prod_role_btn{
    width: 100%;
    height: .73rem;
    background: #4378ff;
    color: #fff;
    text-align: center;
    line-height: 0.73rem;
    font-size: .28rem;
  }
</style>